const gridProfile = {
  gridProfile: {
    pageHeader: 'Profil réseau',
    name: 'Nom',
    description: 'Description',
    createdBy: 'Créé par',
    noGrid: '** Aucun réseau disponible **',
    grids: 'Réseaux'
  }
};

export default gridProfile;
